<template>
  <div class="m_container">
    <MHeader></MHeader>
    <router-view></router-view>
    <MFooter></MFooter>
  </div>
</template>

<script>
import MHeader from "../../components/common/MHeader.vue";
import MFooter from "../../components/common/MFooter.vue";

export default {
  components: {
    MHeader,
    MFooter,
  },
};
</script>
